import { motion } from "framer-motion";
import { Users, Snowflake, UtensilsCrossed, Wind } from "lucide-react";
import { EXPERIENCE } from "../../data";
import { fadeUp, stagger, viewportOnce, viewportSome } from "../../lib/motion";

const ICONS = [Users, Snowflake, UtensilsCrossed, Wind];

export const Experience = () => (
  <section id="experiencia" data-testid="experience" className="relative bg-ink py-24 sm:py-32 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="max-w-3xl"
      >
        <div className="overline mb-6">La experiencia</div>
        <h2 className="font-display font-light text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
          No es un tour. Es una <em className="italic text-ember">expedición hecha a medida</em>.
        </h2>
        <p className="mt-8 font-body font-light text-base sm:text-lg text-[var(--muted)] max-w-xl leading-relaxed">
          En The W Project creemos en otra forma de viajar, comer y amar. Sin prisa,
          respetuosos con el entorno y libres de prejuicios. Vivencias genuinas y
          exclusivas para quienes buscan lo salvaje de verdad.
        </p>
      </motion.div>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewportSome}
        className="mt-16 sm:mt-24 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10"
      >
        {EXPERIENCE.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <motion.div
              key={item.n}
              variants={fadeUp}
              data-testid={`experience-item-${i}`}
              className="group bg-ink p-8 sm:p-12 hover:bg-ink-2 transition-colors duration-500"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-5xl sm:text-6xl text-white/15 group-hover:text-glacier transition-colors duration-500">
                  {item.n}
                </span>
                <Icon className="h-6 w-6 text-glacier" strokeWidth={1.4} />
              </div>
              <h3 className="mt-10 font-display text-3xl sm:text-4xl font-light">{item.title}</h3>
              <p className="mt-4 font-body font-light text-sm sm:text-base text-[var(--muted)] leading-relaxed max-w-md">
                {item.text}
              </p>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  </section>
);
